var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemarksIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.476527 1.23502H15.5154C15.79 1.23502 16 1.02502 16 0.758489C16 0.491957 15.79 0.290039 15.5154 0.290039H0.476527C0.201918 0.290039 0 0.491957 0 0.758489C0 1.02502 0.201918 1.23502 0.476527 1.23502ZM0.476527 5.46722H15.5154C15.79 5.46722 16 5.2653 16 4.99877C16 4.73224 15.79 4.52224 15.5154 4.52224H0.476527C0.201918 4.52224 0 4.73224 0 4.99877C0 5.2653 0.201918 5.46722 0.476527 5.46722ZM0.476527 9.70751H8.83594C9.10247 9.70751 9.31247 9.49751 9.31247 9.23098C9.31247 8.96445 9.10247 8.76253 8.83594 8.76253H0.476527C0.201918 8.76253 0 8.96445 0 9.23098C0 9.49751 0.201918 9.70751 0.476527 9.70751Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemarksIcon);
export default __webpack_public_path__ + "static/media/RemarksIcon.d38162641d5546f6fb19af28ead1565e.svg";
export { ForwardRef as ReactComponent };